import { useEffect, useState } from "react";
import ReactSelect from "react-select";
import {
  listActividadEconomica19,
  listAmbiente001,
  listDepartamento012,
  listMunicipio013
} from "../api/hacienda";
import { listClientData, updateCliente } from "../api/clientes";
import Loader from "../components/Loader";
import {
  FiUpload, FiImage, FiSettings, FiGlobe, FiMail,
  FiPhone, FiInfo, FiShield, FiLock, FiLink,
  FiServer, FiCheckCircle, FiCpu, FiKey, FiRefreshCw
} from "react-icons/fi";
import { generarTokenDiario } from "../api/facturar";
import { showAlertExito, showAlertError } from "../utils/alertHelper";

const Configuracion = () => {
  const [loading, setLoading] = useState(true);
  const [actividad, setActividadEconomica] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [ambiente, setAmbiente] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [municipiosFiltrados, setMunicipiosFiltrados] = useState([]);

  const [form, setForm] = useState({
    id_actividadEconomicaFacts: "",
    name: "",
    nombreComercial: "",
    direccion: "",
    nit: "",
    nrc: "",
    company: "",
    website: "",
    ambiente: "",
    urlFirmador: "",
    authPassword: "",
    privatePassword: "",
    phone: "",
    correoEnvio: "",
    OAuth2: "",
    envioAutomatico: 0,
    whatsapp: 0,
  });


  useEffect(() => {
    const fetchData = async () => {
      try {
        const act = await listActividadEconomica19({});
        setActividadEconomica(act.data);

        const amb = await listAmbiente001({});
        setAmbiente(amb.data);

        const dep = await listDepartamento012({});
        setDepartamentos(dep.data);

        const mun = await listMunicipio013({});
        setMunicipios(mun.data);

        const clienteData = await listClientData();
        setCliente(clienteData.data);

        setForm(clienteData.data);

        if (clienteData.data.departamento) {
          const filtrados = mun.data.filter(
            (m) => m.id_departamentoFact === Number(clienteData.data.departamento)
          );
          setMunicipiosFiltrados(filtrados);
        }
      } catch (error) {
        console.error("Error al obtener datos", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleActividadChange = (selected) => {
    setForm((prev) => ({
      ...prev,
      id_actividadEconomicaFacts: selected ? selected.value : "",
    }));
  };

  const handleAmbienteChange = (selected) => {
    setForm((prev) => ({
      ...prev,
      ambiente: selected ? selected.value : "",
    }));
  };

  const handleDepartamentoChange = (selected) => {
    const depId = selected ? selected.value : "";
    setForm((prev) => ({
      ...prev,
      departamento: depId,
    }));

    if (depId) {
      const filtrados = municipios.filter(
        (m) => m.id_departamentoFact === Number(depId)
      );
      setMunicipiosFiltrados(filtrados);
    } else {
      setMunicipiosFiltrados([]);
    }
  };

  const handleMunicipioChange = (selected) => {
    setForm((prev) => ({
      ...prev,
      municipio: selected ? selected.value : "",
    }));
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleGenerarToken = async () => {
    try {
      setSubmitting(true);
      const res = await generarTokenDiario({ token_diario: form.token_diario });
      if (res && res.estado === 1) {
        setForm(prev => ({ ...prev, token_diario: res.token }));
        showAlertExito("Éxito", res.msg || "Token generado exitosamente");
      } else {
        showAlertError("Error", res?.msg || "Error al generar token");
      }
    } catch (error) {
      console.error("Error al generar token:", error);
      showAlertError("Error", "Error interno al procesar la solicitud");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    setSubmitting(true);
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("id_actividadEconomicaFacts", form.id_actividadEconomicaFacts);
      formData.append("name", form.name);
      formData.append("nombreComercial", form.nombreComercial);
      formData.append("direccion", form.direccion);
      formData.append("nit", form.nit);
      formData.append("email", form.email);
      formData.append("nrc", form.nrc);
      formData.append("company", form.company);
      formData.append("website", form.website);
      formData.append("ambiente", form.ambiente);
      formData.append("urlFirmador", form.urlFirmador);
      formData.append("authPassword", form.authPassword);
      formData.append("privatePassword", form.privatePassword);
      formData.append("phone", form.phone);
      formData.append("correoEnvio", form.correoEnvio);
      formData.append("envioAutomatico", form.envioAutomatico);
      formData.append("whatsapp", form.whatsapp);
      formData.append("OAuth2", form.OAuth2);
      formData.append("token_diario", form.token_diario || "");
      if (logoFile) {
        formData.append("logo", logoFile);
      }

      await updateCliente(formData);

    } catch (error) {
      console.error("Error al guardar el producto", error);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading || !cliente) return <Loader />;


  const opcionesActividades = actividad.map((a) => ({
    value: a.id,
    label: `${a.codigo} | ${a.name}`,
  }));


  const opcionesAmbiente = ambiente.map((am) => ({
    value: am.id,
    label: `${am.codigo} | ${am.name}`,
  }));


  const selectedActividad = opcionesActividades.find(
    (a) => a.value === form.id_actividadEconomicaFacts
  );

  const selectedAmbiente = opcionesAmbiente.find(
    (am) => am.value === form.ambiente
  );

  const opcionesDepartamentos = departamentos.map((d) => ({
    value: d.id,
    label: `${d.codigo} | ${d.name}`,
  }));

  const opcionesMunicipios = municipiosFiltrados.map((m) => ({
    value: m.id,
    label: `${m.codigo} | ${m.name}`,
  }));

  const selectedDepartamento = opcionesDepartamentos.find(
    (d) => Number(d.value) === Number(form.departamento)
  );

  const selectedMunicipio = opcionesMunicipios.find(
    (m) => Number(m.value) === Number(form.municipio)
  );

  return (
    <form onSubmit={handleSubmit} className="space-y-6 p-6">
      <h2 className="text-2xl font-bold">Configuración</h2>
      {/* Sección 1: Configuración del Negocio */}
      <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 w-full overflow-hidden">
        <div className="flex items-center gap-3 mb-8 border-b border-slate-50 pb-4">
          <div className="bg-blue-50 p-2 rounded-lg">
            <FiSettings className="text-blue-600 w-6 h-6" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-800">Datos del Negocio</h2>
            <p className="text-sm text-slate-500">Información básica y visual de tu empresa</p>
          </div>
        </div>

        {/* Sección del Logo Rediseñada */}
        <div className="mb-10 bg-slate-50 p-6 rounded-2xl border border-slate-200/60 flex flex-col md:flex-row items-center gap-8 transition-all hover:border-blue-200 group">
          <div className="relative">
            <div className="w-32 h-32 md:w-40 md:h-40 bg-white rounded-2xl border-2 border-dashed border-slate-300 flex items-center justify-center p-2 shadow-inner overflow-hidden group-hover:border-blue-400 transition-colors">
              {logoPreview || form.logo ? (
                <img
                  src={logoPreview || (process.env.REACT_APP_RUTA_LOGO && form.logo ? `${process.env.REACT_APP_RUTA_LOGO}${form.logo}` : "")}
                  alt="Logo del negocio"
                  className="max-w-full max-h-full object-contain"
                />
              ) : (
                <FiImage className="w-12 h-12 text-slate-300" />
              )}
            </div>
          </div>

          <div className="flex-1 space-y-4 text-center md:text-left">
            <div>
              <h3 className="text-lg font-semibold text-slate-800">Logo del Negocio</h3>
              <p className="text-sm text-slate-500">Sube el logo que aparecerá en tus documentos tributarios</p>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <label className="cursor-pointer flex items-center gap-2 px-4 py-2 bg-white border border-slate-300 hover:border-blue-500 hover:text-blue-600 rounded-xl text-sm font-medium transition-all shadow-sm">
                <FiUpload className="w-4 h-4" />
                <span>Elegir Nueva Imagen</span>
                <input
                  type="file"
                  className="hidden"
                  accept="image/*"
                  onChange={handleLogoChange}
                />
              </label>
              {form.logo && (
                <span className="text-xs text-slate-400 font-mono bg-white px-3 py-1.5 rounded-lg border border-slate-200">
                  Archivo actual: {form.logo}
                </span>
              )}
            </div>
            <p className="text-[10px] text-slate-400 uppercase tracking-wider font-semibold">Formatos recomendados: PNG, JPG (Máx 2MB)</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { label: "Nombre", name: "name", icon: <FiInfo className="w-4 h-4" /> },
            { label: "Nombre Comercial", name: "nombreComercial", icon: <FiInfo className="w-4 h-4" /> },
            { label: "Dirección", name: "direccion", icon: <FiGlobe className="w-4 h-4" /> },
            { label: "Teléfono", name: "phone", icon: <FiPhone className="w-4 h-4" /> },
            { label: "Correo Electrónico", name: "email", icon: <FiMail className="w-4 h-4" /> },
            { label: "Sitio Web", name: "website", icon: <FiGlobe className="w-4 h-4" /> },
            { label: "NIT", name: "nit", icon: <FiInfo className="w-4 h-4" /> },
            { label: "NRC", name: "nrc", icon: <FiInfo className="w-4 h-4" /> },
          ].map(({ label, name, icon }) => (
            <div key={name} className="space-y-1.5">
              <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
                <span className="text-slate-400">{icon}</span>
                {label}
              </label>
              <input
                type="text"
                name={name}
                value={form[name] || ""}
                onChange={handleInputChange}
                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all placeholder:text-slate-300"
              />
            </div>
          ))}


          <div>
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1 mb-1.5">
              <span className="text-slate-400"><FiCpu className="w-4 h-4" /></span>
              Actividad Económica
            </label>
            <ReactSelect
              options={opcionesActividades}
              value={selectedActividad}
              onChange={handleActividadChange}
              isClearable
              isSearchable
              className="react-select-container"
              classNamePrefix="react-select"
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

        </div>
      </section>

      {/* Sección 2: Configuración de Correo Rediseñada */}
      <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 w-full">
        <div className="flex items-center gap-3 mb-8 border-b border-slate-50 pb-4">
          <div className="bg-emerald-50 p-2 rounded-lg">
            <FiMail className="text-emerald-600 w-6 h-6" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-800">Correo envío DTE</h2>
            <p className="text-sm text-slate-500">Configuración para el envío automático de comprobantes</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiMail className="w-4 h-4" /></span>
              Correo Envío
            </label>
            <input
              type="text"
              name="correoEnvio"
              value={form.correoEnvio || ""}
              onChange={handleInputChange}
              placeholder="correo@ejemplo.com"
              className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all"
            />
          </div>

          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiShield className="w-4 h-4" /></span>
              OAuth2
            </label>
            <input
              type="password"
              name="OAuth2"
              value={form.OAuth2}
              onChange={handleInputChange}
              className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all"
            />
          </div>

          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiCheckCircle className="w-4 h-4" /></span>
              Envío Correo Automático
            </label>
            <select
              name="envioAutomatico"
              value={form.envioAutomatico}
              onChange={handleInputChange}
              className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all appearance-none cursor-pointer"
            >
              <option value="1">Activo</option>
              <option value="0">Inactivo</option>
            </select>
          </div>
        </div>
      </section>


      {/* Sección 3: Notificaciones por WhatsApp */}
      <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 w-full">
        <div className="flex items-center gap-3 mb-8 border-b border-slate-50 pb-4">
          <div className="bg-green-50 p-2 rounded-lg">
            <FiPhone className="text-green-600 w-6 h-6" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-800">Envío por WhatsApp (WS)</h2>
            <p className="text-sm text-slate-500">Configuración para el envío de facturas emitidas a través de WhatsApp</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiCheckCircle className="w-4 h-4" /></span>
              Activar envío automático
            </label>
            <select
              name="whatsapp"
              value={form.whatsapp !== undefined ? form.whatsapp : 0}
              onChange={handleInputChange}
              className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-green-500/20 focus:border-green-500 outline-none transition-all appearance-none cursor-pointer"
            >
              <option value="1">Activo</option>
              <option value="0">Inactivo</option>
            </select>
          </div>
        </div>
      </section>

      {/* Sección 4: Hacienda Rediseñada */}
      <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 w-full">
        <div className="flex items-center gap-3 mb-8 border-b border-slate-50 pb-4">
          <div className="bg-slate-800 p-2 rounded-lg">
            <FiServer className="text-white w-6 h-6" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-slate-800">Cifrado y Hacienda</h2>
            <p className="text-sm text-slate-500">Credenciales del Ministerio de Hacienda y firma electrónica</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiGlobe className="w-4 h-4" /></span>
              Ambiente
            </label>
            <ReactSelect
              options={opcionesAmbiente}
              value={selectedAmbiente}
              onChange={handleAmbienteChange}
              isClearable
              isSearchable
              className="react-select-container"
              classNamePrefix="react-select"
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiLink className="w-4 h-4" /></span>
              URL Firmador
            </label>
            <input
              type="text"
              name="urlFirmador"
              value={form.urlFirmador || ""}
              onChange={handleInputChange}
              className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-slate-500/20 focus:border-slate-800 outline-none transition-all"
            />
          </div>

          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiKey className="w-4 h-4" /></span>
              Token Diario
            </label>
            <div className="relative group">
              <input
                type="text"
                name="token_diario"
                value={form.token_diario || ""}
                onChange={handleInputChange}
                className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-slate-500/20 focus:border-slate-800 outline-none transition-all pr-12"
                placeholder="Token diario..."
              />
              <button
                type="button"
                onClick={handleGenerarToken}
                disabled={submitting}
                title="Generar nuevo token"
                className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <FiRefreshCw className={`w-4 h-4 ${submitting ? 'animate-spin' : ''}`} />
              </button>
            </div>
          </div>

          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiLock className="w-4 h-4" /></span>
              Password Privado
            </label>
            <input
              type="password"
              name="privatePassword"
              value={form.privatePassword}
              onChange={handleInputChange}
              className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-slate-500/20 focus:border-slate-800 outline-none transition-all"
            />
          </div>

          <div className="space-y-1.5">
            <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 ml-1">
              <span className="text-slate-400"><FiLock className="w-4 h-4" /></span>
              Password Token
            </label>
            <input
              type="password"
              name="authPassword"
              value={form.authPassword}
              onChange={handleInputChange}
              className="w-full bg-white border border-slate-200 rounded-xl px-4 py-2.5 text-slate-600 focus:ring-2 focus:ring-slate-500/20 focus:border-slate-800 outline-none transition-all"
            />
          </div>
        </div>
      </section>



      {/* Botón de guardar Modernizado */}
      <div className="text-right pt-4">
        <button
          type="submit"
          disabled={submitting}
          className={`group px-8 py-3 rounded-2xl flex items-center justify-center gap-3 transition-all font-bold text-white shadow-lg ${submitting
            ? "bg-slate-400 cursor-not-allowed"
            : "bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 hover:shadow-blue-500/25 active:scale-95"
            }`}
        >
          {submitting ? (
            <span className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
          ) : (
            <FiCheckCircle className="w-5 h-5 group-hover:scale-110 transition-transform" />
          )}
          {submitting ? "Actualizando Datos..." : "Guardar Cambios"}
        </button>
      </div>
    </form>
  );
};

export default Configuracion;
